var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.5h-11V.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v11H.5c-.3 0-.5.2-.5.5s.2.5.5.5h11v11c0 .3.2.5.5.5s.5-.2.5-.5v-11h11c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 2H20V.5c0-.3-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5V2H8V.5c0-.3-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5V2H.5c-.3 0-.5.2-.5.5v21c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5v-21c0-.3-.2-.5-.5-.5zM17 1h2v3h-2V1zM5 1h2v3H5V1zM4 3v1.5c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5V3h8v1.5c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5V3h3v4H1V3h3zM1 23V8h22v15H1z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "caret-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 5.1c-.2-.2-.5-.2-.7 0L12 17.7.9 5.2C.7 5 .4 4.9.2 5.1c-.2.2-.3.5-.1.7l11.5 13c.1.1.2.2.4.2s.3-.1.4-.2l11.5-13c.2-.2.1-.5-.1-.7z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "caret-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3 12L18.8.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-13 11.5s-.1.2-.1.3.1.3.2.4l13 11.5c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.2-.5 0-.7L6.3 12z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "caret-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 11.6L5.8.1c-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7L17.7 12 5.2 23.1c-.2.2-.2.5 0 .7 0 .1.2.2.3.2.1 0 .2 0 .3-.1l13-11.5c.1-.1.2-.2.2-.4s-.1-.3-.2-.4z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "caret-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9 18.2l-11.5-13c-.2-.2-.6-.2-.7 0L.2 18.2c-.2.2-.2.5 0 .7.2.2.5.2.7 0L12 6.3l11.1 12.6c.1.1.2.2.4.2.1 0 .2 0 .3-.1.2-.3.3-.6.1-.8z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "chat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 20.4c1.2-1.1 1.9-2.5 1.9-4.1 0-3.2-2.9-6-6.4-6.4.2-.7.4-1.4.4-2.1C18 3.7 14 .3 9.1.3 4 .3 0 3.6 0 7.7c0 1.9.9 3.7 2.3 5 0 0 .1 0 .1.1L.5 16c-.1.2-.1.4.1.6.1.1.2.2.4.2h.2l4.8-2c.1 0 .2.1.3.1.9.2 1.7.3 2.7.3h.1c-.1.4-.1.7-.1 1 0 2.1 1.2 4.1 3.1 5.4 2.1 1.3 4.6 1.6 6.9.6l3.8 1.4h.2c.1 0 .3-.1.4-.2.1-.2.2-.4.1-.6l-1.4-2.4zM9 14.2c-.8 0-1.6-.1-2.3-.3-.3-.1-.5-.1-.7-.2l-1.6.6-2.2.9.7-1.2v-.1l.8-1.5c-.4-.3-.8-.6-1.1-.9-1-1-1.6-2.3-1.6-3.8 0-3.5 3.6-6.4 8-6.4s7.9 2.9 7.9 6.5c0 .7-.1 1.4-.4 2-3.2 0-6.1 1.9-7.1 4.5-.2-.1-.3-.1-.4-.1zm10.2 7.1h-.4c-2 .9-4.3.7-6.2-.5C11 19.7 10 18 10 16.2c0-3 3-5.5 6.5-5.5s6.5 2.5 6.5 5.5c0 1.4-.6 2.6-1.8 3.6-.2.2-.3.5-.2.7l.9 1.9-2.7-1.1z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9.1c-.2-.2-.5-.2-.7 0L12 11.3.9.1C.7 0 .3 0 .1.2 0 .4 0 .7.1.9L11.3 12 .1 23.1c-.2.2-.2.5 0 .7.2.2.5.2.7 0L12 12.7l11.1 11.1c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L12.7 12 23.9.9c.1-.2.1-.6 0-.8z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8 3h-6V.5c0-.3-.2-.5-.5-.5h-8c-.4 0-.5.2-.5.5V3h-6c-.3 0-.6.2-.6.5s.3.5.6.5h2v19.5c0 .3.2.5.4.5h16c.3 0 .5-.2.5-.5V4h2c.3 0 .5-.2.5-.5S23 3 22.8 3zm-14-2h7v2h-7V1zm11 22h-15V4h15v19z"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H.5c-.3 0-.5-.2-.5-.5V17c0-.3.2-.5.5-.5s.5.2.5.5v4h22v-4.2c0-.3.2-.5.5-.5s.5.2.5.5v4.7c0 .2-.2.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 12.2c-.2-.2-.5-.2-.7 0l-3 3V2.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.7l-3-3c-.1-.2-.5-.2-.7 0s-.2.5 0 .7l3.8 3.8s.1.1.2.1h.4c.1 0 .1-.1.2-.1l3.8-3.8c.2-.2.2-.5 0-.7z"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5c-.3 0-.5.2-.5.5v12H1V3h15.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5v21c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V11c0-.3-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5.5c-.5-.5-1.4-.7-2.1 0L11.9 10l-.1.1-1.4 2.9c-.2.4.2.9.7.7l2.8-1.4.1-.1 9.5-9.5c.7-.8.6-1.7 0-2.2zM13.4 11.4l-1.4.7.7-1.4L20.4 3l.7.7-7.7 7.7zm9.4-9.5L21.7 3l-.7-.7 1.1-1.1c.3-.3.6-.1.7 0 .1 0 .4.3 0 .7z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4H.5c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5v-15c0-.3-.2-.5-.5-.5zM22 5l-10 8L2 5h20zM1 19V5.5L11.7 14c.1.1.2.1.3.1s.2 0 .3-.1L23 5.5V19H1z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "external-link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 12.8c-.3 0-.5.2-.5.5V23H1V3.9h9.7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H.8c-.4 0-.8.4-.8.8v19.5c0 .4.4.8.8.8h19.5c.4 0 .8-.4.8-.8v-9.9c0-.3-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 0H18c-.3 0-.5.2-.5.5s.2.5.5.5h4.3L7.1 16.2c-.2.2-.2.5 0 .7.1.1.3.1.4.1s.3 0 .4-.1L23 1.7V6c0 .3.2.5.5.5s.5-.2.5-.5V.8c0-.4-.4-.8-.8-.8z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "file-csv",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.642 15.521c-.04-.013-.099-.024-.172-.039-.482-.09-.712-.211-.712-.656 0-.456.333-.826.742-.826.389 0 .714.338.739.77.017.275.254.5.528.471a.502.502 0 0 0 .469-.528C13.182 13.751 12.417 13 11.5 13c-.961 0-1.742.818-1.742 1.825 0 .897.515 1.45 1.604 1.655.038.012.094.021.163.035.484.088.715.209.715.657 0 .456-.332.827-.74.827-.39 0-.716-.339-.741-.771a.5.5 0 0 0-.998.058c.056.962.82 1.714 1.739 1.714.96 0 1.74-.818 1.74-1.826 0-.904-.515-1.456-1.598-1.653zM6.91 13.999c.303 0 .641.065.808.847a.501.501 0 0 0 .979-.212c-.291-1.352-1.132-1.635-1.786-1.635C5 12.999 5 15.025 5 16s0 3 1.91 3c.654 0 1.495-.283 1.786-1.635a.503.503 0 0 0-.384-.596.508.508 0 0 0-.595.385c-.166.782-.504.846-.807.846-.515 0-.91-.146-.91-2s.395-2.001.91-2.001zm11.235-.978a.5.5 0 0 0-.623.334L16.5 16.76l-1.021-3.402a.499.499 0 1 0-.957.287l1.5 5a.499.499 0 0 0 .957 0l1.5-5a.502.502 0 0 0-.334-.624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.961 6.308a.508.508 0 0 0-.107-.162L15.856.147A.531.531 0 0 0 15.5 0h-13a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19c.275 0 .5-.225.5-.5v-17a.503.503 0 0 0-.039-.192zM16 1.707L20.293 6H16V1.707zM3 23V1h12v5.5a.5.5 0 0 0 .5.5H21v16H3z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "file-doc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6.3c0-.1-.1-.1-.1-.2l-6-6s-.1-.1-.2-.1H2.5c-.3 0-.5.2-.5.5v23c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V6.3zm-6-4.6L20.3 6H16V1.7zM3 23V1h12v5.5c0 .3.2.5.5.5H21v16H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 14c.3 0 .6.1.8.8.1.3.3.4.6.4.3-.1.4-.3.4-.6-.3-1.4-1.1-1.6-1.8-1.6-1.9 0-1.9 2-1.9 3s0 3 1.9 3c.7 0 1.5-.3 1.8-1.6.1-.3-.1-.5-.4-.6-.3-.1-.5.1-.6.4-.2.8-.5.8-.8.8-.5 0-.9-.1-.9-2s.4-2 .9-2zM12 13c-2 0-2 2.1-2 3 0 .9 0 3 2 3s2-2.1 2-3c0-.9 0-3-2-3zm0 5c-.5 0-1-.1-1-2s.5-2 1-2 1 .1 1 2-.5 2-1 2zm-5.5-5h-1c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5h1C7.9 19 9 17.7 9 16s-1.1-3-2.5-3zm0 5H6v-4h.5c.9 0 1.5.8 1.5 2s-.6 2-1.5 2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "file-pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6.3c0-.1-.1-.1-.1-.2l-6-6s-.1-.1-.2-.1H2.5c-.3 0-.5.2-.5.5v23c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V6.3zm-6-4.6L20.3 6H16V1.7zM3 23V1h12v5.5c0 .3.2.5.5.5H21v16H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13h-1c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5h1c1.4 0 2.5-1.3 2.5-3s-1.1-3-2.5-3zm0 5H12v-4h.5c.9 0 1.5.8 1.5 2s-.6 2-1.5 2zm6.5-5h-2.5c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5s.5-.2.5-.5V16h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1v-1h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM7.8 13H6.5c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5s.5-.2.5-.5v-2h.8c1 0 1.8-.8 1.8-1.8S8.7 13 7.8 13zm0 2.5H7V14h.8c.4 0 .8.3.8.8s-.4.7-.8.7z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "file-ppt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13h-2c-.3 0-.5.2-.5.5s.2.5.5.5h.5v4.5c0 .3.2.5.5.5s.5-.2.5-.5V14h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6.3c0-.1-.1-.1-.1-.2l-6-6s-.1-.1-.2-.1H2.5c-.3 0-.5.2-.5.5v23c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V6.3zm-6-4.6L20.3 6H16V1.7zM3 23V1h12v5.5c0 .3.2.5.5.5H21v16H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 13H6.5c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5s.5-.2.5-.5v-2h.8c1 0 1.8-.8 1.8-1.8S8.7 13 7.8 13zm0 2.5H7V14h.8c.4 0 .8.3.8.8s-.4.7-.8.7zm5-2.5h-1.2c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5s.5-.2.5-.5v-2h.8c1 0 1.8-.8 1.8-1.8s-1-1.7-1.9-1.7zm0 2.5H12V14h.8c.4 0 .8.3.8.8s-.4.7-.8.7z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "file-xls",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6.3c0-.1-.1-.1-.1-.2l-6-6s-.1-.1-.2-.1H2.5c-.3 0-.5.2-.5.5v23c0 .3.2.5.5.5h19c.3 0 .5-.2.5-.5V6.3zm-6-4.6L20.3 6H16V1.7zM3 23V1h12v5.5c0 .3.2.5.5.5H21v16H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18h-2v-4.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5c0 .3.2.5.5.5H14c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm3.6-2.5h-.2c-.5-.1-.7-.2-.7-.7 0-.5.3-.8.7-.8.4 0 .7.3.7.8 0 .3.2.5.5.5s.5-.3.5-.5c-.1-1-.8-1.7-1.7-1.7-1 0-1.7.8-1.7 1.8 0 .9.5 1.5 1.6 1.7h.2c.5.1.7.2.7.7 0 .5-.3.8-.7.8-.4 0-.7-.3-.7-.8 0-.3-.2-.5-.5-.5s-.5.3-.5.5c.1 1 .8 1.7 1.7 1.7 1 0 1.7-.8 1.7-1.8 0-.9-.5-1.5-1.6-1.7zm-8.8-2.4c-.2-.1-.5-.1-.7.2L7 15l-1.1-1.8c-.1-.2-.4-.3-.7-.2-.2.1-.3.4-.2.7L6.4 16l-1.3 2.2c-.1.2-.1.5.2.7 0 .1.1.1.2.1.2 0 .3-.1.4-.2L7 17l1.1 1.8c.1.1.2.2.4.2.1 0 .2 0 .3-.1.2-.1.3-.4.2-.7L7.6 16l1.3-2.2c.2-.3.1-.6-.1-.7z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4H9.7L7.9 2.1c-.1 0-.3-.1-.4-.1h-7c-.3 0-.5.2-.5.5v19c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5v-17c0-.3-.2-.5-.5-.5zM23 21H1V3h6.3l1.9 1.9s.2.1.3.1H23v16z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "help",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 23C6 23 1 18 1 12S6 1 12 1s11 5 11 11-5 11-11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.7c-2 0-3.7 1.6-3.7 3.7 0 .3.2.5.5.5s.5-.2.5-.5c0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6S13.4 12 12 12c-.3 0-.5.2-.5.5v3.1c0 .3.2.5.5.5s.5-.2.5-.5V13c1.8-.3 3.1-1.8 3.1-3.6.1-2-1.6-3.7-3.6-3.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18.3,
    r: 1
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "home",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.5h-6c-.3 0-.5-.2-.5-.5v-6.5h-4V23c0 .3-.2.5-.5.5h-6c-.3 0-.5-.2-.5-.5V13H.5c-.2 0-.4-.1-.4-.3-.1-.2 0-.4.1-.5L11.7.6c.2-.2.5-.2.7 0l11.5 11.5c.1.1.2.3.1.5s-.2.3-.4.3H21v10c0 .4-.2.6-.5.6zm-5.5-1h5v-10c0-.3.2-.5.5-.5h1.8L12 1.7 1.6 12h1.8c.4 0 .6.2.6.5v10h5V16c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5v6.5z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "information",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 23C6 23 1 18 1 12S6 1 12 1s11 5 11 11-5 11-11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 18.8h-2.6V9.9c0-.3-.2-.5-.5-.5H9.9c-.3 0-.5.2-.5.5s.2.5.5.5h1.6v8.3H8.9c-.3 0-.5.2-.5.5s.2.5.5.5h6.3c.3 0 .5-.2.5-.5 0-.2-.3-.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 5.7,
    r: 1
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "location",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.6 0 4 3.6 4 8c0 4.2 7.3 15.3 7.6 15.8.1.1.2.2.4.2s.3-.1.4-.2C12.7 23.3 20 12.2 20 8c0-4.4-3.6-8-8-8zm0 22.6C10.4 20.1 5 11.4 5 8c0-3.9 3.1-7 7-7s7 3.1 7 7c0 3.4-5.4 12.1-7 14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "navigation-menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8 3.7h22.5c.4 0 .7-.3.7-.7s-.3-.8-.8-.8H.8c-.5 0-.8.4-.8.8s.3.7.8.7zm22.4 4.5H.8c-.5 0-.8.4-.8.8s.3.8.8.8h22.5c.4-.1.7-.4.7-.8s-.3-.8-.8-.8zm0 6.1H.8c-.5 0-.8.3-.8.7s.3.8.8.8h22.5c.4 0 .8-.3.8-.8s-.4-.7-.9-.7zm0 6H.8c-.5 0-.8.3-.8.7 0 .4.3.8.8.8h22.5c.4 0 .8-.3.8-.8-.1-.4-.4-.7-.9-.7z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "password",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24h17a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5H18V6c0-3.309-2.691-6-6-6S6 2.691 6 6v3H3.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5zM7 6c0-2.757 2.243-5 5-5s5 2.243 5 5v3H7V6zm-3 4h16v13H4V10z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1 17.2l-2.6-2.6c-.6-.6-1.3-.9-2.1-.9s-1.5.3-2.1.9l-.5.5c-2.5-2.1-5-4.6-7.1-7.1l.5-.5c1.1-1.1 1.1-3 0-4.2L6.8.8C5.7-.3 3.8-.3 2.6.8L1.2 2.3C-.2 3.7-.4 5.9.7 7.5c4.1 6.2 9.6 11.7 15.8 15.8.7.5 1.5.7 2.3.7 1.1 0 2.1-.4 2.9-1.2l1.4-1.4c.6-.6.9-1.3.9-2.1s-.3-1.5-.9-2.1zm-.7 3.4L21 22c-1 1-2.7 1.2-3.9.4C11 18.4 5.6 13 1.6 6.9.7 5.7.9 4 1.9 3l1.4-1.4c.4-.4.9-.6 1.4-.6s1 .2 1.3.6l2.6 2.6c.7.7.7 1.9 0 2.7l-.9.8c-.2.2-.2.5 0 .7 2.3 2.8 5.1 5.6 7.9 7.9.2.2.5.2.7 0l.9-.9c.4-.4.8-.6 1.3-.6s1 .2 1.3.6l2.6 2.6c.4.4.6.8.6 1.3s-.2 1-.6 1.3z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "play",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 24c-.1 0-.2 0-.3-.1-.1-.1-.2-.2-.2-.4V.5C0 .3.1.2.2.1c.2-.1.4-.1.5 0l23 11.5c.2.1.3.3.3.4s-.1.4-.3.4L.7 23.9c0 .1-.1.1-.2.1zM1 1.3v21.4L22.4 12 1 1.3z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "print",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 7H19V4.3c0-.1-.1-.1-.1-.2l-3-3s-.1-.1-.2-.1H5.5c-.3 0-.5.2-.5.5V7H2.5C1.1 7 0 8.1 0 9.5v6C0 16.9 1.1 18 2.5 18H5v4.5c0 .3.2.5.5.5h13c.3 0 .5-.2.5-.5V18h2.5c1.4 0 2.5-1.1 2.5-2.5v-6C24 8.1 22.9 7 21.5 7zM16 2.7L17.3 4H16V2.7zM6 2h9v2.5c0 .3.2.5.5.5H18v2H6V2zm12 20H6v-7h12v7zm5-6.5c0 .8-.7 1.5-1.5 1.5H19v-2.5c0-.3-.2-.5-.5-.5h-13c-.3 0-.5.2-.5.5V17H2.5c-.8 0-1.5-.7-1.5-1.5v-6C1 8.7 1.7 8 2.5 8h19c.8 0 1.5.7 1.5 1.5v6z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "save",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-20c-.1 0-.3.1-.3.1l-3.1 3c0 .1-.1.2-.1.4v19.9c0 .4.2.6.5.6h23c.3 0 .5-.2.5-.5V.5c0-.3-.2-.5-.5-.5zm-3.7 1v4h-9.5V1h9.5zM9.4 1v4H5.8V1h3.6zM23 23H1V3.8L3.8 1h1.1v4.5c0 .3.2.5.5.5h14.9c.3 0 .5-.2.5-.5V1H23v22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5c-1.6 0-2.7 1.3-2.7 2.7 0 1.6 1.3 2.7 2.7 2.7s2.7-1.3 2.7-2.7c0-1.5-1.1-2.7-2.7-2.7zm0 4.5c-.9 0-1.8-.7-1.8-1.8 0-.9.7-1.8 1.8-1.8.9 0 1.8.7 1.8 1.8 0 1-.9 1.8-1.8 1.8z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9 23.1l-9-9c1.3-1.5 2.2-3.5 2.2-5.6C17 3.8 13.2 0 8.5 0S0 3.8 0 8.5 3.8 17 8.5 17c2.2 0 4.1-.8 5.6-2.2l9 9c.2.2.5.2.7 0 .2-.1.2-.5.1-.7zM1 8.5C1 4.4 4.4 1 8.5 1S16 4.4 16 8.5 12.6 16 8.5 16 1 12.6 1 8.5z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "share",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9c-.3 0-.5.2-.5.5V23H1V9h4.5c.3 0 .5-.2.5-.5S5.8 8 5.5 8h-5c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-14c0-.3-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 4.1l-4-4c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L22.3 4H14c-3.3 0-6 2.7-6 6v1.5c0 .3.2.5.5.5s.5-.2.5-.5V10c0-2.8 2.2-5 5-5h8.3l-3.1 3.1c-.2.2-.2.5 0 .7s.5.2.7 0l4-4c.1-.1.1-.5 0-.7z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "snail-mail",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12h4c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5h-4c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5zm.5-4h3v3h-3V8zM4.5 9h2c.3 0 .5-.2.5-.5S6.8 8 6.5 8h-2c-.3 0-.5.2-.5.5s.2.5.5.5zm0 6h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-9c-.3 0-.5.2-.5.5s.2.5.5.5zm0 2h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-12c-.3 0-.5.2-.5.5s.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4H.5c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5v-15c0-.3-.2-.5-.5-.5zM23 19H1V5h22v14z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "subtract",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.5H.5c-.3 0-.5.2-.5.5s.2.5.5.5h23c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7 8.1l-7.1 6.7-2.2-2.2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l2.5 2.5c.2.2.5.2.7 0l7.5-7c.2-.2.2-.5 0-.7-.2-.1-.5-.2-.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 23C5.9 23 1 18.1 1 12S5.9 1 12 1s11 4.9 11 11-4.9 11-11 11z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1c.3 0 .5-.2.5-.5V2.7l3.1 3.1c.2.2.5.2.7 0s.2-.5 0-.7l-4-4c-.2-.2-.5-.2-.7 0l-4 4c-.2.2-.2.5 0 .7s.5.2.7 0l3.1-3.1v12.9c.1.3.3.5.6.5zM23.5 22H.5c-.3 0-.5-.2-.5-.5V17c0-.3.2-.5.5-.5s.5.2.5.5v4h22v-4.2c0-.3.2-.5.5-.5s.5.2.5.5v4.7c0 .3-.2.5-.5.5z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 24H1.3c-.3 0-.5-.2-.5-.5v-2.1c0-1.6 1-3.1 2.6-3.6l5.3-1.9v-2.5C7 12 5.9 9.7 5.9 7.2 5.9 3.2 8.6 0 12 0s6.1 3.2 6.1 7.2c0 2.5-1.1 4.8-2.8 6.1v2.5l5.3 1.9c1.5.5 2.6 2 2.6 3.6v2.1c0 .4-.3.6-.5.6zM1.8 23h20.3v-1.6c0-1.2-.8-2.3-1.9-2.7l-5.6-2c-.2-.1-.3-.3-.3-.5v-3.1c0-.2.1-.4.2-.5 1.6-1.1 2.6-3.2 2.6-5.4C17.1 3.8 14.8 1 12 1S6.9 3.8 6.9 7.2c0 2.2 1 4.3 2.6 5.4.2.1.2.3.2.5v3.1c0 .2-.1.4-.3.5l-5.6 2c-1.1.4-1.9 1.5-1.9 2.7V23z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "video",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 5.5c-.1-.1-.3-.1-.5 0l-5.8 2.9V7c0-1.4-1.1-2.5-2.5-2.5H2.5C1.1 4.5 0 5.6 0 7v10c0 1.4 1.1 2.5 2.5 2.5H15c1.4 0 2.5-1.1 2.5-2.5v-1.7l5.8 2.8c.1 0 .1.1.2.1s.2 0 .3-.1c.1-.1.2-.3.2-.4V6c0-.2-.1-.4-.2-.5zM16.5 17c0 .8-.7 1.5-1.5 1.5H2.5c-.8 0-1.5-.6-1.5-1.5V7c0-.8.7-1.5 1.5-1.5H15c.8 0 1.5.7 1.5 1.5v10zm6.5 0l-5.5-2.7V9.6L23 6.8V17z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 0H12C5.3.1-.1 5.6 0 12.2.1 18.8 5.3 24 11.8 24h.2c6.7-.1 12.1-5.6 12-12.2C23.9 5.2 18.7 0 12.2 0zM12 23h-.2C5.9 23 1.2 18.2 1 12.2.9 6.2 5.9 1.1 12 1h.2C18.1 1 22.8 5.8 23 11.8c.1 6-4.9 11-11 11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1c.3 0 .5-.2.5-.5V6.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v7.3c0 .3.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.2,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiIcons);
export default __webpack_public_path__ + "static/media/indi_icons.0998aed1d58adfe05a04383376dcce43.svg";
export { ForwardRef as ReactComponent };